import {Box, Button, Card, Dialog} from "@mui/material";
import {getItemByName} from "../../../core/utils/constants";
import {DataGrid} from "@mui/x-data-grid";
import CmChargeBlock from "../../Charger/cm/cmChargeBlock";
import React, {useState} from "react";

export default function Tricks({tricks}) {

    const [selectedRows, setSelectedRows] = useState([]);
    const disable = selectedRows.length === 0

    const [chargeItemsDialog, setChargeItemsDialog] = useState(false);
    const [selectedItemList, setSelectedItemList] = useState([{
        id: Math.random(),
        type: null,
        category: null,
        key: null,
        amount: null,
        date: null,
        customFields: null
    }]);

    const columns = [
        {field: 'name', headerName: 'Name', hide: false, width: 700},
        {field: 'data', headerName: 'Data', hide: false, width: 700},
    ]

    let rows = [
        {id: "hummer", type: "items", category: "Trick", name: "Hummer", data: getItemByName(tricks, "hummer").Count},
        {id: "bomb", type: "items", category: "Trick", name: "Bomb", data: getItemByName(tricks, "bomb").Count},
        {id: "color", type: "items", category: "Trick", name: "Color", data: getItemByName(tricks, "color").Count},
        {id: "glove", type: "items", category: "Trick", name: "Glove", data: getItemByName(tricks, "glove").Count},
    ]

    const handleSelectRows = (ids) => {
        const selectedIDs = new Set(ids);
        const selectedRowData = rows.filter((row) =>
            selectedIDs.has(row.id.toString()));
        setSelectedRows(selectedRowData);
        setSelectedItemList(selectedRowData.map(item =>
            ({
                id: Math.random(),
                type: item.type,
                category: item.category,
                key: item.id,
                amount: item.data,
                date: null,
                customFields: null
            })
        ));
    }

    return (
        <Card>
            <Button
                disabled={disable}
                variant={'contained'}
                color={"success"}
                onClick={() => setChargeItemsDialog(!chargeItemsDialog)}>
                Charge items
            </Button>
            <Box sx={{width: '100%', height: 600}}>
                <DataGrid
                    checkboxSelection={true}
                    onSelectionModelChange={(ids) => handleSelectRows(ids)}
                    columns={columns}
                    rows={rows}>
                </DataGrid>
            </Box>
            <Dialog open={chargeItemsDialog} fullWidth={true}>
                <CmChargeBlock
                    massCharge={false}
                    selectedItemList={selectedItemList}
                    setSelectedItemList={setSelectedItemList}
                />

                <Button
                    disabled={disable}
                    variant={'contained'}
                    color={"success"}
                    onClick={() => setChargeItemsDialog(!chargeItemsDialog)}>
                    Cancel
                </Button>

            </Dialog>
        </Card>
    );
}
